<template>
  <div class="container">
    <form
      class="needs-validation"
      id="page-form"
      @submit.prevent="validateBeforeSubmit($event, proceed)"
      data-toggle="validator"
      novalidate
    >
      <div class="form-group-container">
        <div class="col-12">
          <h1 class="page-title">Edit</h1>
        </div>
        <div class="introduction row">
          <div class="col-12"></div>
        </div>
        <div class="col-12 col-lg-12 clear-padding-left" v-if="this.updateSuccessful">
          <div class="alert alert-success">
            <p class>Details have been updated.</p>
          </div>
        </div>
        <div class="col-12 col-md-10 center-align" v-if="!this.updateSuccessful">
          <div v-if="loaded">
            <YesNoInput
              id="item.isActive"
              :errors="this.errors"
              :value="item.isActive"
              label="Is active?"
              @update="UPDATE_FIELD"
            />

            <Textbox
              id="item.firstname"
              :errors="this.errors"
              :value="item.firstname"
              @update="UPDATE_FIELD"
              label="First name"
            />
            <Textbox
              id="item.lastname"
              :errors="this.errors"
              :value="item.lastname"
              @update="UPDATE_FIELD"
              label="Last name"
            />
            <Textbox
              id="item.accessFailedCount"
              :errors="this.errors"
              :value="item.accessFailedCount"
              @update="UPDATE_FIELD"
              label="Access failed count"
            />

            <DatePicker
              @update="UPDATE_FIELD"
              name="item.lockoutEnd"
              id="item.lockoutEnd"
              :errors="this.errors"
              :value="item.starts"
              label="Lockout end"
              @change="UPDATE_FIELD('item.lockoutEnd', $event.target.value)"
            ></DatePicker>
            <YesNoInput
              id="item.lockoutEnabled"
              :errors="this.errors"
              :value="item.lockoutEnabled"
              label="Lockout enabled?"
              @update="UPDATE_FIELD"
            />
            <div class="form-group row button-top-margin">
              <div class="col-12 col-lg-4"></div>
              <div class="col-12 col-lg-8">
                <div class="row">
                  <div class="col-4 col-md-4 login-btns">
                    <button type="submit" class="btn default-btn-color btn-primary">Update</button>
                  </div>
                  <div class="col-4 col-md-4">
                    <router-link class="btn default-btn-color btn-primary" to="/admin/users">Cancel</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import { UserAdminService } from "@/services/UserAdminService";
import Tooltip from "@/components/controls/Tooltip.vue";
import Textbox from "@/components/controls/Textbox.vue";
import Textarea from "@/components/controls/Textarea.vue";
import YesNoInput from "@/components/controls/YesNoInput.vue";
import DatePicker from "@/components/controls/DatePicker.vue";
import rbValidator from "@/mixins/rbValidator";
import * as Validators from "@/utils/validators";
import * as FormFieldValidators from "@/utils/form-field-validators";
import commonMixin from "@/mixins/commonMixin";
import formUpdateMixin from "@/mixins/formUpdateMixin";
import currencyFilter from "@/filters/currencyFilter";
import dateFilter from "@/filters/dateFilter";

var validations = {
  "item.firstname": FormFieldValidators.generic_required,
  "item.lastname": FormFieldValidators.generic_required,
  //"item.lockoutEnd": FormFieldValidators.date,
  //"item.shortDescription": FormFieldValidators.generic_required,
  "item.accessFailedCount": FormFieldValidators.number,
  "item.isActive": FormFieldValidators.generic_required,
  "item.lockoutEnabled": FormFieldValidators.generic_required
};

export default {
  name: "EditUser",
  mixins: [formUpdateMixin, commonMixin, rbValidator],
  filters: { currencyFilter, dateFilter },
  props: [],
  components: {
    Tooltip,
    Textbox,
    Textarea,
    YesNoInput,
    DatePicker
  },
  data() {
    return {
      updateSuccessful: false,
      id: "",
      loaded: false,
      validations: validations,
      submitMessage: "",
      item: {
        firstname: "",
        lastname: "",
        lockoutEnd: "",
        accessFailedCount: "",
        isActive: null,
        lockoutEnabled: null
      }
    };
  },
  methods: {
    UPDATE_FIELD(key, value) {
      // //this.$data[key] = value;
      this.setFieldValue(this.item, key, value);
    },
    async getById() {
      var response = await UserAdminService.read(this.id);
      this.item = response.data;
      this.loaded = true;
      setTimeout(() => {
        this.init("form", this.validations);
      }, 400);
    },
    proceed() {
      this.save();
    },
    async save() {
      var response = await UserAdminService.update(this.id, JSON.parse(JSON.stringify(this.item)));
      this.updateSuccessful = true;
      this.redirectToRoute("/admin/users");
    },
    resetValue(name) {
      this.item[name] = "";
    }
  },
  computed: {
    // promoHasValue() {
    //   return this.item.percentageOff > 0 ||
    //     this.item.amountOff > 0 ||
    //     this.item.freeDelivery === "true"
    //     ? 1
    //     : "";
    // }
  },
  created() {
    this.id = this.$route.params.id;
    this.getById();

    // setTimeout(() => {
    //   this.init("page-form", this.validations);
    // }, 400);
  },
  mounted() {}
};
</script>

<style scoped>
#item_percentageOff_item_amountOff_item_freeDelivery_container.is-invalid {
  border: 1px solid #fb7784;
  padding: 5px;
}
</style>